import { configureStore } from '@reduxjs/toolkit';
import base from './slice';

export const store = configureStore({
    reducer: {
        counter: base,
    },
});
